<template>
    <div class="app-container">
        <div class="filter-container">
            <div style="display:flex; flex-wrap: wrap; justify-content: space-between; align-items: center;">
                <div>
                    <el-button type="primary" icon="el-icon-edit" @click="handleAddTable">新增</el-button>
                    <el-button type="primary" icon="el-icon-s-operation"
                        @click="CategoryManagementVisible = true">分类管理</el-button>
                    <el-button type="warning" icon="el-icon-upload2" :loading="tableLoading"
                        @click="exportExcel">导出Excel</el-button>
                </div>
                <div>
                    <div class="filter-item">
                        <el-input v-model="listQuery.name" placeholder="商品名称" />
                    </div>
                    <div class="filter-item">
                        <el-select v-model="listQuery.state" placeholder="状态" clearable>
                            <el-option label="正常" :value="1" />
                            <el-option label="下架" :value="0" />
                        </el-select>
                    </div>
                    <el-button type="primary" icon="el-icon-search" :loading="tableLoading" @click="getList">搜索</el-button>
                </div>
            </div>
        </div>

        <div class="table-list">
            <el-table v-loading="tableLoading" element-loading-text="Loading" :data="tableData" border fit height="65vh"
                highlight-current-row>
                <el-table-column type="index" label="序号" width="95" align="center" />
                <el-table-column prop="cover_img" label="图片" width="200" align="center">
                    <template slot-scope="scope">
                        <el-image style="height: 124px" :src="scope.row.cover_img" fit="cover"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名称" min-width="180" align="center" />
                <el-table-column prop="commodity_class_info.name" label="分类" width="180" align="center" />
                <el-table-column prop="integral_worth" label="所需积分" width="134" align="center" />
                <el-table-column prop="stock_num" label="总数量" width="134" align="center" />
                <el-table-column label="剩余库存" width="134" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.stock_num - scope.row.exchange_num }}
                    </template>
                </el-table-column>
                <el-table-column prop="exchange_num" label="兑换人数" width="134" align="center" />
                <el-table-column prop="sort" label="排序" width="134" align="center" />
                <el-table-column prop="state" label="状态" width="134" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="(scope.row.state === 1)" type="success">正常</el-tag>
                        <el-tag v-else type="danger">下架</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEditTable(scope.row)">编辑</el-button>

                        <el-button :type="scope.row.state ? 'warning' : 'success'" size="mini" :loading="btnLoading"
                            @click="handleState(scope.row.id, scope.row.state ? '下架' : '上架')">{{
                                scope.row.state ? '下架'
                                : '上架'
                            }}</el-button>

                        <!-- <el-popconfirm title="确定删除?" @confirm="handleDelete(scope.row.id)"   @onConfirm="handleDelete(scope.row.id)" style="margin-left: 10px;">
                            <el-button type="danger" slot="reference" size="mini" :loading="btnLoading">删除</el-button>
                        </el-popconfirm> -->
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    :total="total" background layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>

        <TableActiveModal v-if="visible" :show.sync="visible" :type="modalType" :edit-data="editData"
            @onUpdate="onTableActionModalSubmit" />
        <CategoryManagementModal :show.sync="CategoryManagementVisible" />
    </div>
</template>

<script>
// 积分商城 商品列表
import TableActiveModal from "./components/TableActiveModal.vue"
import CategoryManagementModal from "./components/CategoryManagementModal.vue"
import { productList } from "@/api/creditShop"
import * as XLSX from "xlsx"

export default {
    data: () => ({
        tableLoading: false,
        tableData: [],
        listQuery: {
            page: 1,
            limit: 10,
            name: '',
            state: null
        },
        total: null,
        visible: false,
        modalType: 'add',
        editData: {},
        CategoryManagementVisible: false,
        btnLoading: false
    }),
    components: { TableActiveModal, CategoryManagementModal },
    methods: {
        async getList() {
            this.tableLoading = true
            this.tableData = []
            const { data } = await productList.list(this.listQuery)
            let formatData = data.data.sort((v1, v2) => v2.sort - v1.sort)
            this.tableData = formatData
            this.total = data.total
            this.tableLoading = false
        },
        handleFilter() {
            this.listQuery.page = 1
            this.getList()
        },
        // 分页操作
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        handleAddTable() {
            this.setActiveModalType('add')
            this.visible = true
        },
        handleEditTable(data) {
            this.editData = data
            this.setActiveModalType('edit')
            this.visible = true
        },
        setActiveModalType(type) {
            this.modalType = type
        },
        handleState(id, text) {
            this.$confirm("此操作将" + text + "该商品, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(async () => {
                    try {
                        this.btnLoading = true
                        await productList.changeState(id)
                        this.getList();
                        this.$message({
                            type: "success",
                            message: "操作成功!"
                        });
                    } catch {
                        this.$message.error('出错了!');
                    } finally {
                        this.btnLoading = false
                    }
                })
        },
        async handleDelete(id) {
            console.log('handleDelete', id);
            try {
                this.btnLoading = true
                await productList.delete(id)
                this.getList()
                this.$message({
                    message: '操作成功!',
                    type: 'success'
                });
            } catch {
                // this.$message.error('出错了!');
            } finally {
                this.btnLoading = false
            }
        },
        onTableActionModalSubmit() {
            this.getList()
        },
        // 导出Excel
        async exportExcel() {
            console.log('exportExcel')

            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await productList.list({ ...this.listQuery, page: 1, limit: total })

                var wb = XLSX.utils.book_new();

                var excelData = [
                    ['序号', '名称', '分类', '所需积分', '总数量', '剩余库存', '兑换人数', '状态'],
                    ...reqData.map((item, index) => [
                        index + 1,
                        item.name,
                        item.commodity_class_info.name,
                        item.integral_worth,
                        item.stock_num,
                        item.stock_num - item.exchange_num,
                        item.exchange_num,
                        item.state ? '正常' : '下架'
                    ])
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "商品列表");
                XLSX.writeFile(wb, "积分商城-商品列表.xlsx");

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped></style>